import React from "react";
import { FiUsers, FiStar } from "react-icons/fi";

interface MySuppliersEmptyStateProps {
	variant: "no-suppliers" | "no-ratings";
}

export const MySuppliersEmptyState: React.FC<MySuppliersEmptyStateProps> = ({
	variant,
}) => {
	if (variant === "no-suppliers") {
		return (
			<div
				className="flex flex-col items-center justify-center py-16 text-center"
				data-testid="empty-state-no-suppliers"
			>
				<div className="mb-4 rounded-full bg-gray-100 p-4">
					<FiUsers className="h-8 w-8 text-gray-400" />
				</div>
				<h3 className="mb-2 text-lg font-semibold text-gray-900">
					No suppliers yet
				</h3>
				<p className="max-w-md text-sm text-gray-500">
					Suppliers will appear here once they have been awarded contracts
					through your RFx processes.
				</p>
			</div>
		);
	}

	return (
		<div
			className="flex flex-col items-center justify-center py-16 text-center"
			data-testid="empty-state-no-ratings"
		>
			<div className="mb-4 rounded-full bg-blue-50 p-4">
				<FiStar className="h-8 w-8 text-blue-400" />
			</div>
			<h3 className="mb-2 text-lg font-semibold text-gray-900">
				No performance ratings yet
			</h3>
			<p className="max-w-md text-sm text-gray-500">
				Rate your suppliers to track their performance over time and make
				informed procurement decisions.
			</p>
		</div>
	);
};
